module.exports = __webpack_public_path__ + "static/media/test_specialFormatting_default.d5d9e7eb.csv";